import { Injectable } from '@angular/core';

import { Group } from '@era/security-sdk';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap, mergeMap } from 'rxjs/operators';
import { RouterStoreStates, AclRouterStoreSelectors } from '../router';
import { UserGroupStoreSelectors, UserGroupStoreActions } from '../user-group';

@Injectable()
export class UserGroupResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly userGroupStore: Store<Group>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(AclRouterStoreSelectors.selectCurrentAclId).pipe(
      mergeMap((x) =>
        this.userGroupStore.select(UserGroupStoreSelectors.selectGroupByParentId(x)).pipe(
          tap((y) => {
            if (y.length < 1) {
              this.userGroupStore.dispatch(
                UserGroupStoreActions.UserGroupResolverActions.userGroupsRequested({ userId: x })
              );
            }
          })
        )
      ),
      map(() => true),
      first()
    );
  }
}
